import { Media } from "./common.js";
import { AppEmbedData_AppType } from "./plugin_app_embed.enums.js";
function appEmbedData_AppTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "PRODUCT":
      return AppEmbedData_AppType.PRODUCT;
    case 1:
    case "EVENT":
      return AppEmbedData_AppType.EVENT;
    case 2:
    case "BOOKING":
      return AppEmbedData_AppType.BOOKING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AppEmbedData_AppType.UNRECOGNIZED;
  }
}
function appEmbedData_AppTypeToJSON(object) {
  switch (object) {
    case AppEmbedData_AppType.PRODUCT:
      return "PRODUCT";
    case AppEmbedData_AppType.EVENT:
      return "EVENT";
    case AppEmbedData_AppType.BOOKING:
      return "BOOKING";
    default:
      return "UNKNOWN";
  }
}
const baseAppEmbedData = { type: AppEmbedData_AppType.PRODUCT };
const AppEmbedData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData };
    message.type = object.type !== void 0 && object.type !== null ? appEmbedData_AppTypeFromJSON(object.type) : AppEmbedData_AppType.PRODUCT;
    message.itemId = object.itemId !== void 0 && object.itemId !== null ? String(object.itemId) : void 0;
    message.name = object.name !== void 0 && object.name !== null ? String(object.name) : void 0;
    message.imageSrc = object.imageSrc !== void 0 && object.imageSrc !== null ? String(object.imageSrc) : void 0;
    message.url = object.url !== void 0 && object.url !== null ? String(object.url) : void 0;
    message.image = object.image !== void 0 && object.image !== null ? Media.fromJSON(object.image) : void 0;
    message.bookingData = object.bookingData !== void 0 && object.bookingData !== null ? AppEmbedData_BookingData.fromJSON(object.bookingData) : void 0;
    message.eventData = object.eventData !== void 0 && object.eventData !== null ? AppEmbedData_EventData.fromJSON(object.eventData) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.type !== void 0 && (obj.type = appEmbedData_AppTypeToJSON(message.type));
    message.itemId !== void 0 && (obj.itemId = message.itemId);
    message.name !== void 0 && (obj.name = message.name);
    message.imageSrc !== void 0 && (obj.imageSrc = message.imageSrc);
    message.url !== void 0 && (obj.url = message.url);
    message.image !== void 0 && (obj.image = message.image ? Media.toJSON(message.image) : void 0);
    message.bookingData !== void 0 && (obj.bookingData = message.bookingData ? AppEmbedData_BookingData.toJSON(message.bookingData) : void 0);
    message.eventData !== void 0 && (obj.eventData = message.eventData ? AppEmbedData_EventData.toJSON(message.eventData) : void 0);
    return obj;
  }
};
const baseAppEmbedData_BookingData = {};
const AppEmbedData_BookingData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_BookingData };
    message.durations = object.durations !== void 0 && object.durations !== null ? String(object.durations) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.durations !== void 0 && (obj.durations = message.durations);
    return obj;
  }
};
const baseAppEmbedData_EventData = {};
const AppEmbedData_EventData = {
  fromJSON(object) {
    const message = { ...baseAppEmbedData_EventData };
    message.scheduling = object.scheduling !== void 0 && object.scheduling !== null ? String(object.scheduling) : void 0;
    message.location = object.location !== void 0 && object.location !== null ? String(object.location) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.scheduling !== void 0 && (obj.scheduling = message.scheduling);
    message.location !== void 0 && (obj.location = message.location);
    return obj;
  }
};
export {
  AppEmbedData,
  AppEmbedData_BookingData,
  AppEmbedData_EventData,
  appEmbedData_AppTypeFromJSON,
  appEmbedData_AppTypeToJSON
};
//# sourceMappingURL=plugin_app_embed.js.map
